import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  ElementRef,
  QueryList,
  ViewChild
} from '@angular/core';
import { gsap, Sine} from "gsap";
import Masonry from 'masonry-layout';

@Component({
  selector: 'app-style-pictures-moodboard',
  templateUrl: './style-pictures-moodboard.component.html',
  styleUrls: ['./style-pictures-moodboard.component.scss']
})
export class StylePicturesMoodboardComponent implements OnInit {

  @Input() labels:any;
  @Input() stylePictures: any;
  // @Input() stylePicturesOrdered: any;
  @Input() solutions: any;
  @Input() section_id:string;

  @Output() onShowStylePic: EventEmitter<Array<string>> = new EventEmitter();


  @ViewChildren('masonryItem', { read: ElementRef })
  masonryItems!: QueryList<ElementRef>;

  @ViewChild('grid') grid!: ElementRef;
  private masonry!: any;

  constructor() { }

  ngOnInit(): void {
    let i = -1;
    while (++i < this.stylePictures.length){
      const idimg = this.stylePictures[i].id;
      const sol = this.solutions?.find(elm => elm.idPicture === idimg );
      if(sol && sol.models[0]) {
        this.stylePictures[i].name = sol?.models[0]?.name;
        this.stylePictures[i].manufacturer = sol.models[0]?.manufacturer;
      }
    }


    this.layout();
    //
    // this.masonryItems.changes.subscribe(() => {
    //   this.layout();
    // });
  }

  reorderForColumns<T>(items: T[], columns: number): T[] {
    const rows = Math.ceil(items.length / columns);
    const result: T[] = [];

    for (let col = 0; col < columns; col++) {
      for (let row = 0; row < rows; row++) {
        const index = row * columns + col;

        if (index < items.length) {
          result.push(items[index]);
        }
      }
    }

    return result;
  }

  onImageLoad() {
    this.layout();
    setTimeout(() => {
      this.masonry?.layout();
    });
  }

  layout() {

    // this.stylePicturesOrdered =  this.reorderForColumns(this.stylePictures, 3);
    // const grid = document.querySelector('.masonry') as HTMLElement;
    // if (!grid) return;
    //
    // const rowHeight = parseInt(getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    // const rowGap = parseInt(getComputedStyle(grid).getPropertyValue('gap'));
    //
    // this.masonryItems.forEach((item: ElementRef) => {
    //   const el = item.nativeElement;
    //
    //   const height = el.getBoundingClientRect().height;
    //
    //   const span = Math.ceil((height + rowGap) / (rowHeight + rowGap));
    //
    //   el.style.gridRowEnd = `span ${span}`;
    // });
  }
  ngAfterViewInit(): void {

    setTimeout(() => {
      this.masonry = new Masonry(this.grid.nativeElement, {
        itemSelector: '.moodboard-item',
        columnWidth: '.moodboard-item',
        gutter: 20,
        percentPosition: true
      });
    });
    // let revealContainers = document.querySelectorAll("#"+this.section_id+" .spmreveal");
    //
    // revealContainers.forEach((container, index) => {
    //   let tl = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: container,
    //       // toggleActions: "restart none none reset",
    //       scrub: 1,
    //       start:'start 95%',
    //       end:"top 50%",
    //       markers:false,
    //     }
    //   });
    //
    //   tl.set(container, { autoAlpha: 0});
    //   tl.to(container, 1, {
    //     autoAlpha:1,
    //     y:0,
    //     ease: Sine.easeIn,
    //     delay:(index%3)*.5
    //   });
    // });

    let revealBox= document.querySelector("#"+this.section_id+" .moodboard-grid");
    
    console.log('StylePicturesMoodboardComponent - ngAfterViewInit - revealBox >>> ', revealBox  );

    // tolto l'animazione ora che c'è masondry e messo un fade al blocco intero
    gsap.fromTo(revealBox, {

      autoAlpha:0}, {

      autoAlpha:1,
      ease: Sine.easeInOut,

      scrollTrigger: {
        end:"bottom +=250px",
        scrub: true,
      }
    });


    // const title = document.querySelector('.products-animated-grid .title');
    gsap.utils.toArray(".style-pictures-moodboard-title").forEach((elem:any, index:number) => {

      gsap.fromTo(elem, {
        maskSize:"+=0", webkitMaskSize:"+=0",
        transformOrigin:"top", autoAlpha:.8}, {

        autoAlpha:1,
        maskSize:'+=300%',
        webkitMaskSize:"+=300%",
        ease: Sine.easeInOut,

        scrollTrigger: {
          end:"top 50%",
          markers:false,
          trigger: elem,
          scrub: true,
          id:"title "
        }
      });
    });
  }


  onShowImg(url:string) {
    this.onShowStylePic.emit([url]);
  }
}
